import { PunchoutCheckout } from '../../../../components/Punchout/PunchoutCheckout.js';

export const PunchoutCheckoutPath = () => <PunchoutCheckout />;
